import type { GeoRunStatus, GeoTargetStatus, GeoTargetType } from "../types";

/** GEO 治理批次列表查询键。 */
export const geoGovernanceRunsQueryKey = ["geo-governance", "runs"] as const;

/** GEO 治理运行环境状态查询键。 */
export const geoGovernanceRuntimeStatusQueryKey = ["geo-governance", "runtime-status"] as const;

/** GEO 治理批次详情查询键前缀。 */
export const geoGovernanceRunQueryKey = (runId: string) => ["geo-governance", "run", runId] as const;

/** GEO 治理对象查询键前缀。 */
export const geoGovernanceTargetsQueryKey = (runId: string, filters: object) =>
  ["geo-governance", "targets", runId, filters] as const;

/** GEO 治理候选查询键。 */
export const geoGovernanceCandidatesQueryKey = (targetId: string) =>
  ["geo-governance", "candidates", targetId] as const;

/** 可治理对象类型选项及其执行规则。 */
export const geoTargetTypeOptions: Array<{
  label: string;
  value: GeoTargetType;
  description: string;
}> = [
  {
    label: "学校校区",
    value: "school_campus",
    description: "LLM 结合学校、校区和校区数判断；无校区高校先回业务页新增校区。",
  },
  {
    label: "住宿点",
    value: "stay_area",
    description: "LLM 确认区域中心，再由高德地理编码取坐标，不调用 POI。",
  },
  {
    label: "资源酒店",
    value: "stay_resource",
    description: "LLM 识别经营地址，高德地理编码；地址不足时最多调用一次 POI。",
  },
  {
    label: "考察点",
    value: "resource_point",
    description: "普通考察点先 LLM 再高德；非遗（point_sub_type=6）直接按人工地址地理编码，非遗不调用 LLM 或 POI。",
  },
  {
    label: "机场/航站楼",
    value: "airport",
    description: "LLM 结合 IATA、ICAO 和航站楼判断，必要时最多调用一次机场 POI。",
  },
  {
    label: "火车站",
    value: "train_station",
    description: "保留 12306 telecode 门禁，地理编码不足时最多调用一次火车站 POI。",
  },
];

/** 治理列表和业务入口使用的精简对象类型名称。 */
export const geoTargetTypeShortLabels: Record<GeoTargetType, string> = {
  school_campus: "学校校区",
  stay_area: "住宿点",
  stay_resource: "资源酒店",
  resource_point: "考察点",
  airport: "机场",
  train_station: "火车站",
};

/** 批次状态文案。 */
export const geoRunStatusLabels: Record<GeoRunStatus, string> = {
  draft: "待执行",
  running: "待继续执行",
  waiting_review: "待人工处理",
  completed: "已完成",
  failed: "批次失败",
};

/** 对象状态文案。 */
export const geoTargetStatusLabels: Record<GeoTargetStatus, string> = {
  pending: "待执行",
  processing: "处理中",
  resolved: "已通过",
  verified_no_change: "已核验无变化",
  review_required: "待人工处理",
  skipped: "已跳过",
  failed: "技术失败",
};

/** 每页条数选项。 */
export const geoPageSizeOptions = [10, 20, 50, 100];
